import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as Rx from "rxjs"
import { retry } from "rxjs/operators"
import { request } from "../utils/http"

export type GetCustomerOrdersServerResponse = {
    content: CustomerOrderItem[]
    total_count: number
    page_size: number
}

export type CustomerOrderItem = {
    date: string
    order_id: string
    order_number: string
    total: Maybe<number>
}

export const getCustomerOrdersApi = (headers: Record<string, any>, id: string): Rx.Observable<CustomerOrderItem[]> =>
    Rx.defer(() =>
        request({
            method: "GET",
            path: `/data/customer/${id}/orders`,
            headers: headers,
        })
    ).pipe(retry(3))
